<template>
   <div class="steps-container">
       <div class="steps-item" :class="{active:index<=active}" v-for="(item,index) in list" :key="index">
           <div class="steps-item-title">{{item}}</div>
           <div class="steps-line-wrapper">
               <div class="steps-line__cover">
                    <div class="steps-item-circle">
                        <i></i>
                    </div>
                    <div class="steps-item-line"></div>
               </div>
           </div>
       </div>
   </div>
</template>

<script>
/**
 * 
 * steps
 * 
 */
export default {

    props:{

        list:{

            type:Array,

            default:()=>[]

        },

        active:{

            type:Number,

            default:-1

        }

    }

}
</script>

<style scoped lang="less">
.steps-container{

    padding: 12px 15px 20px;

    display: flex;

    background: #fff;

    border-radius:33px;

    .steps-item{

        flex:1;

        .steps-item-title{

            text-align: center;

            font-size:13px;

            color:#d1d1d1;

            white-space: nowrap;

        }

        .steps-line-wrapper{

            position: relative;

            height:15px;
            
            .steps-line__cover{

                position: absolute;
                
                left:-50%;

                width: 100%;

                bottom:0;

                .steps-item-line{

                    height:2px;

                    width: 100%;

                    background:#dcddda;

                }

                .steps-item-circle{

                    position: absolute;

                    right:-7.5px;

                    top:-7px;

                    width: 15px;

                    height:15px;

                    border-radius:50%;

                    background:url(data:image/png;base64,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) no-repeat center center / 100% 100%;

                    z-index:10;

                    text-align: center;
                    

                }

            }

        }

        &:first-child{

            .steps-line-wrapper .steps-line__cover .steps-item-line{

                width: 0;

            }

        }


        &.active{

            .steps-item-title{

                color: #31d381;

            }

            .steps-line-wrapper .steps-line__cover{

                .steps-item-line{

                    background:#31d381;

                }

                .steps-item-circle{

                    
                    background:url(data:image/png;base64,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) no-repeat center center / 100% 100%;

                }

            }

        }

    }

}
</style>
